require([
    'services',
    'jquery',
    'semantic',
    'ch_utils',
    'ch_header',
    'ch_semantic_responsive'
], function() {

    /**
     * addSnippets
     *
     * Fetch rich snippet events via ajax and add to the DOM so Google can see them
     */
    function addSnippets() {
        // Get rich snippets for the page
        const scriptTag = document.createElement('script');
        scriptTag.type = 'application/ld+json';

        $.ajax({
            type: 'GET',
            url: '/course/filter/get-rich-snippets',
            data: {
                courseIds: CH.courseIds
            },
            dataType: 'html',
            success: function (html) {
                scriptTag.innerHTML = html;
                document.head.appendChild(scriptTag);
            },
        });
    }

    function addEventTracking() {
        var $container = $('#guide-filter-container');
        var currentCollection = $('h1.header', '#guide-banner')
            .text()
            .trim();

        $('.back.link', $container).on('click', function(e) {
            ga('send', 'event', 'Guide Filter Page', 'Back To Guide Clicked', currentCollection);
        });

        $('.primary.menu .item', $container).on('click', function() {
            ga('send', 'event', 'Guide Filter Page', 'Sub Menu Clicked', currentCollection + ' | ' + $(this).text().trim());
        });
    }

    $(function() {
        addSnippets();
        addEventTracking();
    });
});
